import React, { PureComponent } from 'react'
import styled from 'styled-components';
import Tile from 'components/commons/Tile';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators'
import { GlobalStyle, Colors } from 'stylecomponents';
import GLOBAL from 'nonnglobal';
/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const tileStyle = {
  tileWidth: 120,
  tileHeight: 155,
  imgWidth: 120,
  imgHeight: 90,
  fontSize: 13,
  type: 'smallBlock',
  margin: '7px 20px 0',
};
/**
|--------------------------------------------------
| Styled
|--------------------------------------------------
*/
const Main = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 20px 12px 0 12px;
`;

const NavList = styled.ul`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.gridNum}, auto) 1fr`};
  grid-auto-flow: column;
  justify-content: start;
  align-items: center;
  margin: 0;
  background-color: #FFF;
  border-bottom: 1px solid #D9D9D9;
`;
const NavItemTouch = styled.div`
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 9px;
  color: inherit;
`;
const NavItem = styled.li`
  margin-left: 30px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
  > div {
    border-bottom: 2px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
  }

  ${NavItemTouch} {
    color: ${props => props.isActive ? Colors.MAIN_COLOR : '#4A4A4A'};
    font-weight: ${props => props.bold && props.isActive ? 'bold':''}
  }

  &:first-child {
    margin-left: ${props => props.marginLeft? props.marginLeft:30}px;
  }
`;
const NavItemLink = styled.a`
  margin-left: 30px;
  font-size: 14px;
  color: ${Colors.MAIN_COLOR};
  font-weight: bold;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const ErrorStatus = styled.div`
  width: 100%;
  color: #737373;
  font-size: 16px;
  text-align: center;
  line-height: 60px;
  height: 60px;
`;


class GameProducts extends PureComponent {

  constructor(props) {
    super(props);

    this.changeTabToBonus = this.changeTab.bind(this, GLOBAL.PRODUCT_CLASS_ID.BONUS_PRODUCT);
    this.changeTabToCard = this.changeTab.bind(this, GLOBAL.PRODUCT_CLASS_ID.POINTCARD_PRODUCT);
    this.changeTabToVitem = this.changeTab.bind(this, GLOBAL.PRODUCT_CLASS_ID.VITEM_PRODUCT);
    this.changeTabToFree = this.changeTab.bind(this, GLOBAL.PRODUCT_CLASS_ID.FREE_PRODUCT);

    this.state = {
      pclassid: GLOBAL.PRODUCT_CLASS_ID.VITEM_PRODUCT,
      isLoading: false,
      isEmpty: false,
      isError: false,
    };
  }

  componentDidMount() {
    this.getGameMappingProducts();
  }

  getGameMappingProducts = () => {

    const { gameid } = this.props;

    const {
      pclassid,
      isLoading,
    } = this.state;

    if(isLoading) return;

    this.setState({
      isLoading: true,
      isError: false,
      isEmpty: false,
    }, () => {
      this.props.gameActions.getGameMappingProducts({
        pclassid,
        gameid,
      }).then(({ resultSize = 0 } = {}) => {
        this.setState({
          isLoading: false,
          isEmpty: resultSize === 0,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          isLoading: false,
          isError: true,
        });
      });
    });
  }

  changeTab = pclassid => {
    this.setState({ pclassid }, () => {
      this.getGameMappingProducts();
    });
  }

  render() {

    const {
      pclassid,
      isLoading,
      isEmpty,
      isError,
    } = this.state;

    const {
      gameid,
      gameMappingProductIdsCache,
      gameMappingProductMap,
      webEventLinkUrl,
    } = this.props;

    const key = this.props.gameActions.getGameMappingProductsCacheKey({ pclassid, gameid });
    const gameMappingProductIds = gameMappingProductIdsCache[key] || {};
    const { ids = [] } = gameMappingProductIds;

    return (
      <GlobalStyle.BasicBlock>
        <NavList gridNum={5} >
          <NavItem
            bold
            isActive={pclassid === GLOBAL.PRODUCT_CLASS_ID.BONUS_PRODUCT}
            onClick={this.changeTabToBonus}
          >
            <NavItemTouch>發財商城</NavItemTouch>
          </NavItem>
          <NavItem
            bold
            isActive={pclassid === GLOBAL.PRODUCT_CLASS_ID.POINTCARD_PRODUCT}
            onClick={this.changeTabToCard}
          >
            <NavItemTouch>點數卡</NavItemTouch>
          </NavItem>
          <NavItem
            bold
            isActive={pclassid === GLOBAL.PRODUCT_CLASS_ID.VITEM_PRODUCT}
            onClick={this.changeTabToVitem}
          >
            <NavItemTouch>虛寶包</NavItemTouch>
          </NavItem>
          <NavItem
            bold
            isActive={pclassid === GLOBAL.PRODUCT_CLASS_ID.FREE_PRODUCT}
            onClick={this.changeTabToFree}
          >
            <NavItemTouch>免費序號</NavItemTouch>
          </NavItem>

          {!!webEventLinkUrl && (
            <NavItemLink
              rel='noopener noreferrer'
              target='_blank'
              href={webEventLinkUrl}
            >
              好康活動
            </NavItemLink>
          )}
        </NavList>
        <Main>
          {!isLoading && !isEmpty && !isError && ids.map(productid => {
              
            const product = gameMappingProductMap[productid];
            const { productname = '', thumbimg } = product;

            const imageSrc = `${GLOBAL.imgSrcRootURL}/goodimgs/${productid}/${thumbimg}`;

            const stateName = GLOBAL.getProductRouterName(product);

            return (
              <Tile
                key={productid}
                tileStyle={tileStyle}
                text={productname.trim()}
                img={imageSrc}
                id={productid}
                detailState={stateName}
              />
            );
          })}

          {isLoading && (
            <GlobalStyle.LoadingContainer>
                <GlobalStyle.Spin />
            </GlobalStyle.LoadingContainer>
          )}

          {isEmpty && (
            <ErrorStatus>尚無商品</ErrorStatus>
          )}

          {isError && (
            <ErrorStatus>發生錯誤，請稍後重新整理後再嘗試</ErrorStatus>
          )}

        </Main>
      </GlobalStyle.BasicBlock>
    );
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    gameMappingProductIdsCache: state.game.gameMappingProductIdsCache,
    gameMappingProductMap: state.game.gameMappingProductMap,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
      gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(GameProducts);
